import { render, staticRenderFns } from "./left.vue?vue&type=template&id=0b9124b6&scoped=true"
import script from "./left.vue?vue&type=script&lang=js"
export * from "./left.vue?vue&type=script&lang=js"
import style0 from "./left.vue?vue&type=style&index=0&id=0b9124b6&prod&lang=css&scoped=true"
import style1 from "./left.vue?vue&type=style&index=1&id=0b9124b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9124b6",
  null
  
)

export default component.exports